<app-header></app-header>

<!-- Page Header Start -->
<div class="container-fluid page-header py-5">
    <div class="container text-center pd-t-120 pd-b-120">
        <h1 class="display-5 text-white mb-4">Our Team</h1>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
                <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                <li class="breadcrumb-item"><a routerLink="/">Pages</a></li>
                <li class="breadcrumb-item" aria-current="page">Team</li>
            </ol>
        </nav>
    </div>
</div>
<!-- Page Header End -->

<!-- Fact Start -->
<div class="container-fluid bg-color-secondary py-5">
  <div class="container">
    <div class="row">
      
      <!-- Loop over facts array using *ngFor -->
      <div *ngFor="let fact of facts" class="col-lg-3">
        <div class="d-flex counter">
          <h1 class="me-3 color-dark counter-value">{{ fact.value }}</h1>
          <h5 class="text-white mt-1">{{ fact.label }}</h5>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- Fact End -->

<!-- Team Start -->
<div class="container-fluid py-5 mb-5 team">
    <div class="container">
        <div class="text-center mx-auto pb-5" style="max-width: 600px;">
            <h5 class="color-primary">Our Team</h5>
            <h1>Meet our expert Team</h1>
        </div>
        <owl-carousel-o [options]="customOptionsTwo" class="owl-btn-center-lr team-carousel">
          <ng-template carouselSlide *ngFor="let slide of teamStore" [id]="slide.id">
            <div class="rounded team-item">
              <div class="team-content">
                <div class="team-img-icon">
        
                  <!-- Member Image -->
                  <div class="team-img rounded-circle">
                    <img [src]="slide.image" class="img-fluid w-100 rounded-circle" [alt]="slide.name">
                  </div>
        
                  <!-- Member Name & Designation -->
                  <div class="team-name text-center py-3">
                    <h4>{{ slide.name }}</h4>
                    <p class="m-0">{{ slide.designation }}</p>
                  </div>
        
                  <!-- Social Icons -->
                  <div class="team-icon d-flex justify-content-center pb-4">
                    <a *ngIf="slide.facebook" class="btn btn-square btn-secondary text-white rounded-circle m-1"
                      [href]="slide.facebook">
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a *ngIf="slide.twitter" class="btn btn-square btn-secondary text-white rounded-circle m-1"
                      [href]="slide.twitter">
                      <i class="fab fa-x-twitter"></i>
                    </a>
                    <a *ngIf="slide.instagram" class="btn btn-square btn-secondary text-white rounded-circle m-1"
                      [href]="slide.instagram">
                      <i class="fab fa-instagram"></i>
                    </a>
                    <a *ngIf="slide.linkedin" class="btn btn-square btn-secondary text-white rounded-circle m-1"
                      [href]="slide.linkedin">
                      <i class="fab fa-linkedin-in"></i>
                    </a>
                  </div>
        
                </div>
              </div>
            </div>
          </ng-template>
        </owl-carousel-o>
    </div>
</div>
<!-- Team End -->